import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { BookOpen } from "lucide-react";
import ClientProfileModal from "./ClientProfileModal";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ClientTherapistRelationship } from "@/types/therapist";

interface ClientCardActionsProps {
  relationship: ClientTherapistRelationship;
  onClientSelect: (clientId: string) => void;
  getClientDisplayName: (client?: ClientTherapistRelationship['client']) => string;
  formatDate: (dateString: string) => string;
  onRelationshipUpdate?: () => void;
}

const ClientCardActions = ({
  relationship,
  onClientSelect,
  getClientDisplayName,
  formatDate,
  onRelationshipUpdate
}: ClientCardActionsProps) => {
  const [isInactiveDialogOpen, setIsInactiveDialogOpen] = useState(false);

  const handleViewJournal = () => {
    if (relationship.status === 'inactive') {
      setIsInactiveDialogOpen(true);
    } else {
      onClientSelect(relationship.client_id);
    }
  };

  return (
    <div className="flex flex-col gap-2 mt-1">
      <div className="flex gap-2">
        <Button 
          onClick={handleViewJournal}
          className="flex-1 bg-[#3BAFDA] hover:bg-[#2a9fc4] text-white transition-all duration-300"
        >
          <BookOpen className="mr-2 h-4 w-4" />
          View Journal
        </Button>
        <ClientProfileModal 
          clientRelationship={relationship}
          open={false}
          onOpenChange={() => {}}
          getClientDisplayName={getClientDisplayName}
          formatDate={formatDate}
        />
      </div>

      <Dialog open={isInactiveDialogOpen} onOpenChange={setIsInactiveDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-amber-600">Connection Inactive</DialogTitle>
            <DialogDescription>
              You are currently disconnected from this client. To view their journal entries, you need to reactivate the connection first.
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-end gap-2 mt-4">
            <Button
              variant="default"
              onClick={() => setIsInactiveDialogOpen(false)}
            >
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ClientCardActions;
